import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { Provider, observer, inject } from 'mobx-react';
import { IntlProvider, injectIntl } from 'react-intl';
import RootStore from './igsupport_components/stores/Root';
import LocaleStore from './common_components/localization/LocaleStore';
import igsupportLocales from '../locales/igsupport.json';
//import {AUTH_EDIT} from "./pitch_components/authorization";
import Index from './igsupport_components/Index';
import Show from './igsupport_components/Show';
import Unauthorized from './memberships_components/Unauthorized';
import BlockUi from "./common_components/BlockUi";

//////// Use Mobx-react-devtools only in development environment ///////////
let DevTools;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  DevTools = require('mobx-react-devtools').default;
} else {
  DevTools = () => null;
}
////////////////////////////////////////////////////////////////////////////

@observer
export default class IgSupport extends React.Component {
  constructor(props) {
    super(props);
    const localeStore = new LocaleStore(props.userLocale, [igsupportLocales]);
    this.rootStore = new RootStore(
      props.currentUser,
      props.userRoles,
      localeStore,
      props.team,
      props.currentStartup,
      props.startup
    );
  }

  render() {
    return (
      <Provider
        rootStore={this.rootStore}
        feedbackChainsStore={this.rootStore.feedbackChainsStore}
        feedbackCommentsStore={this.rootStore.feedbackCommentsStore}
        authorizationsStore={this.rootStore.authorizationsStore}
        valuePropositionsStore={this.rootStore.valuePropositionsStore}
        tasksStore={this.rootStore.tasksStore}
        analyticsStore={this.rootStore.analyticsStore}
      >
        <IntlProvider
          locale={this.rootStore.localeStore.locale}
          messages={this.rootStore.localeStore.messages}
        >
          <BrowserRouter>
            <div id="igsupport" >
              <BlockUi blocking={false}>
                <Switch>
                  <Route
                    path="/:locale?/gstartup/:id/igsupport/chain/:chain"
                    render={props => {
                      return this.props.canShow ? (
                        <Show feedbackChainId={props.match.params.chain} />
                      ) : (
                        <Unauthorized {...this.props} />
                      );
                    }}
                  />
                  <Route
                    path="/:locale?/feedback_chains/:id"
                    render={props => {
                      return this.props.canShow ? (
                        <Show feedbackChainId={props.match.params.chain} />
                      ) : (
                        <Unauthorized {...this.props} />
                      );
                    }}
                  />

                  <Route
                    render={props => {
                      return this.props.canShow ? (
                        <Index />
                      ) : (
                        <Unauthorized {...this.props} />
                      );
                    }}
                  />
                </Switch>
              </BlockUi>
              <DevTools />
            </div>
          </BrowserRouter>
        </IntlProvider>
      </Provider>
    );
  }
}
